<script>
  import {baseApi} from '../../configs/urls'
  import {params, parseError} from '../../packages/Helpers'
  import Permissions from './Permissions'

  export default {
    name: 'base-crud',
    extends: Permissions,
    data () {
      return {
        baseUrl: baseApi,
        dialogTitle: 'Nuevo',
        tableData: [],
        search: '',
        current_page: 1,
        total: 0,
        dialogVisible: false,
        form: {},
        loading: false,
        processing: false,
        rules: {},
        error: {},
        success: false,
        actionText: 'Agregar',
        params: {},
        methodForUpdate: 'put'
      }
    },
    methods: {
      _beforeRefresh (params) {
      },
      _afterRefresh () {
      },
      _getDeleteTitle (model) {
        return 'Esta seguro que desea eliminar ' + model.name
      },
      _getDialogTitle (model) {
        return (model.id) ? 'Editando' : 'Nuevo'
      },
      _formatModel (model) {
      },
      _beforeSend (value) {
        return value
      },
      _mounted () {},
      onChangePagination (event) {
        this.current_page = event
        console.log(this.current_page)
        this.refreshData()
      },
      onChangeSearch (event) {
        this.search = event
        this.refreshData()
      },
      refreshData () {
        const query = {
          page: this.current_page,
          paginate: true
        }

        if (this.search !== '' && this.search !== undefined) {
          query.term = this.search
        }

        this._beforeRefresh(query)

        this.loading = true
        this.$http.get(this.baseUrl + params(query), {
          before (request) {
            // abort previous request, if exists
            if (this.previousRequest) {
              this.previousRequest.abort()
            }

            // set previous request on Vue instance
            this.previousRequest = request
          }
        })
          .then(
            (res) => {
              this.tableData = res.body.data
              this.total = res.body.total
              this.loading = false
              this._afterRefresh()
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
              this.loading = false
            }
          )
      },
      showDialog (model) {
        if (model) {
          const modelFormated = {...model}
          this._formatModel(modelFormated)
          this.actionText = 'Actualizar'
          this.form = modelFormated
        } else {
          this.dialogTitle = 'Nuevo'
          this.actionText = 'Agregar'
          if (this.form.id) {
            this._cleanForm()
            this.$refs.form.resetFields()
          }
        }

        this.dialogTitle = this._getDialogTitle(this.form)
        this.dialogVisible = true
        this.afterShowDialog()
      },
      afterShowDialog () {

      },
      _cleanForm () {
        this.form = {}
      },
      save () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.processing = true
            this.error = {}
            let data = Object.assign({}, this.form)
            data = this._beforeSend(data)
            console.log(data)

            if (!this.form.id) {
              this.$http.post(this.baseUrl, data, this.params)
                .then(
                  () => {
                    this.successAction()
                  },
                  (res) => {
                    this.showErrors(res)
                  }
                )
            } else {
              this.$http[this.methodForUpdate](this.baseUrl + '/' + this.form.id, data, this.params)
                .then(
                  () => {
                    this.successAction()
                  },
                  (res) => {
                    this.showErrors(res)
                  }
                )
            }
          } else {
            return false
          }
        })
      },
      successAction () {
        if (!this.form.id) {
          this.$refs.form.resetFields()
        }

        this.refreshData()
        this.processing = false

        this.success = true
        setTimeout(() => {
          this.success = false
        }, 3000)
      },
      showErrors (res) {
        const [message, errors] = parseError(res)
        this.error = {
          message,
          errors
        }
        this.processing = false
      },
      handleDelete (index, row) {
        this.$confirm(this._getDeleteTitle(row), 'Advertencia', {
          confirmButtonText: 'Si',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.$http.delete(this.baseUrl + '/' + row.id)
            .then(
              () => {
                this.$message({
                  type: 'success',
                  message: 'Eliminado correctamente.'
                })
                this.tableData = this.tableData.filter((item) => {
                  return item.id !== row.id
                })
                this.loading = false
              },
              (res) => {
                this.$message.error(parseError(res)[0])
                this.loading = false
              }
            )
        })
      }
    },
    mounted () {
      this.refreshData()
      this._mounted()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/abstract/BaseCrud.vue